import { type AppDispatch } from "features/Application/globaltypes/redux";
import DataService from "features/Application/services/dataServices/typedDataService";
import { mapFilterOption } from "utils/filterUtils";
import { FiltersEnum } from "../../types";
import { setIsLoading, setFilterOptions } from "../slices/accountsFiltersSlice";

/* istanbul ignore next */
export const fetchFilters = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true));

  try {
    const [labels, accountTypes] = await Promise.all([
      DataService.accounts.getAccountsTags(true),
      DataService.accounts.getFilterOptions(),
    ]);

    const labelsFilterOptions = mapFilterOption({}, labels, FiltersEnum.Tags, (item: string) => ({
      text: item,
      value: item,
    }));

    const options = mapFilterOption(labelsFilterOptions, accountTypes, FiltersEnum.AccountType, (item) => ({
      text: item.name,
      value: item.id,
    }));

    dispatch(setFilterOptions(options));
  } catch (error) {
    console.error("Error fetching filters:", error);
  } finally {
    dispatch(setIsLoading(false));
  }
};
